import { HTMLAttributes } from "react";
import { cn } from "@/lib/cn";

type Tone = "neutral" | "success" | "warning" | "danger" | "info" | "accent";

const tones: Record<Tone, string> = {
  neutral: "bg-white/5 text-fg-muted border-white/10",
  success: "bg-state-success/10 text-state-success border-state-success/20",
  warning: "bg-state-warning/10 text-state-warning border-state-warning/20",
  danger: "bg-state-danger/10 text-state-danger border-state-danger/20",
  info: "bg-state-info/10 text-state-info border-state-info/20",
  accent: "bg-accent/10 text-accent border-accent/20",
};

export function Badge({
  tone = "neutral",
  className,
  ...props
}: HTMLAttributes<HTMLSpanElement> & { tone?: Tone }) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 px-2.5 py-0.5 text-xs font-medium border rounded-full",
        tones[tone],
        className,
      )}
      {...props}
    />
  );
}
